import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Form, FormControl, FormGroup, ButtonToolbar, Button, InputGroup, Row, Col } from 'react-bootstrap'
import Select from 'react-select';
import Moment from 'moment';
import './Stock.css'
// import 'react-datepicker/dist/react-datepicker.css';
import CKAutocomplete from '../../component/element/CKAutocomplete';
import FontAwesome from 'react-fontawesome';
import DatePicker from '../../component/element/DatePicker'
import CkTimePicker from '../../component/element/CkTimePicker'
import WorkdocStore from '../../stores/WorkdocStore'
import StockStore from '../../stores/StockStore'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

const DEFAULT_ROW=  1
class StockPainterBorrowingRecord extends Component {
  constructor(props) {
    super(props)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = Moment().format('MM')
    const curDay = Moment().format('DD')
    const all_day = Moment().daysInMonth()
    let {messages} = this.props
    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = messages['All Month']
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }
    
    const optionsMonth = [
      { value: 0, label: messages['All Year'] },
      { value: '01', label: messages['January'] },
      { value: '02', label: messages['February'] },
      { value: '03', label: messages['March'] },
      { value: '04', label: messages['April'] },
      { value: '05', label: messages['May'] },
      { value: '06', label: messages['June'] },
      { value: '07', label: messages['July'] },
      { value: '08', label: messages['August'] },
      { value: '09', label: messages['September'] },
      { value: '10', label: messages['October'] },
      { value: '11', label: messages['November'] },
      { value: '12', label: messages['December'] }
    ];

    this.state = {
      loading:false,
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultYear: yTh,
      defaultMonth: curMonth,
      defaultDay: curDay,
      customerList: [],
      data: this.newEmptyRow(DEFAULT_ROW,curDay,curMonth,yTh),
      polishing_machine_list: [{id:'1',label:'N1'},{id:'2',label:'N2'},{id:'3',label:'N3'},{id:'4',label:'N4'},{id:'5',label:'N5'},{id:'6',label:'N6'}]
    }

  }

  componentDidMount() {
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.show && newProps.show!==this.props.show){
      let {defaultYear,defaultMonth,defaultDay} = this.state
      this._notificationSystem = this.refs.notificationSystem;
      this.loadWorkdocAutocompleteOfficer()
      this.loadData(defaultYear,defaultMonth,defaultDay)
    }
  }

  loadData(defaultYear,defaultMonth,defaultDay) {
    
    let that = this
    this.setState({loading:true})
    StockStore.loadStockBorrowingPainter(defaultYear-543+'-'+defaultMonth+'-'+defaultDay,function(result) {
      
      let data = result.data.map((item,index)=>{
        item = Object.assign(that.newEmptyRow()[0],item)
        return item
      })
      that.setState({loading:false,data:data})
    },function(){
      that.setState({loading:false,data:[]})
    })
  }

  getDefaultDate(dY,dM,dD){
    
    let defaultYear = (dY===undefined)?this.state.defaultYear:dY
    let defaultMonth = (dM===undefined)?this.state.defaultMonth:dM
    let defaultDay = (dD===undefined)?this.state.defaultDay:dD

    // if(defaultDay*1<10){
    //   defaultDay  = '0'+defaultDay
    // }
    // if(defaultMonth*1<10){
    //   defaultMonth = '0'+defaultMonth
    // }
    return ''+defaultDay+'/'+defaultMonth+'/'+defaultYear
  }

  newEmptyRow(number=1,defaultYear,defaultMonth,defaultDay) {
    return new Array(number).fill(null).map((item,index)=>{
      return {borrowing_item_id:'',is_submit:false,borrowing_date:this.getDefaultDate(defaultYear,defaultMonth,defaultDay),polishing_machine:'',fleece:'',sponge:'',sponge_pad:'',scrub:'',return_date:'',borrower_name:'',borrowing_time:'',return_time:'',fleece_wash:'',asset_borrowing:'',remark:''}
    })
  }

  convertDate(borrowing_date,return_date,index) {
    let {data} = this.state
    let {messages} = this.props
    let status = true
    let bD = borrowing_date.substring(0, 2)
    let bM = borrowing_date.substring(3, 5)
    let bY = borrowing_date.substring(6, 10)
    bY = parseInt(bY) - 543
    let rD = return_date.substring(0, 2)
    let rM = return_date.substring(3, 5)
    let rY = return_date.substring(6, 10)
    rY = parseInt(rY) - 543

    borrowing_date = bY+'-'+bM+'-'+bD
    return_date = rY+'-'+rM+'-'+rD

    let start = Date.parse(borrowing_date)
    let end = Date.parse(return_date)
    if (start>end) {
      status = false
      this._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Date Save Date Back'],
        level: 'error',
        position: 'tc'
      })
    } else if (start===end) {
      let timefrom = new Date()
      let tempStart = data[index].borrowing_time.split(":")
      timefrom.setHours((parseInt(tempStart[0]) - 1 + 24) % 24)
      timefrom.setMinutes(parseInt(tempStart[1]))

      let timeto = new Date()
      let tempEnd = data[index].return_time.split(":")
      timeto.setHours((parseInt(tempEnd[0]) - 1 + 24) % 24)
      timeto.setMinutes(parseInt(tempEnd[1]))

      if (timefrom>timeto) {
        status = false
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Time Save Time Back'],
          level: 'error',
          position: 'tc'
        })
      }
    }
    return status
  }

  convertTime(borrowing_time,return_time,index) {
    let {data} = this.state
    let {messages} = this.props
    let borrowing_date = data[index].borrowing_date
    let return_date = data[index].return_date

    let status = true
    let timefrom = new Date()
    let tempStart = borrowing_time.split(":")
    timefrom.setHours((parseInt(tempStart[0]) - 1 + 24) % 24)
    timefrom.setMinutes(parseInt(tempStart[1]))

    let timeto = new Date()
    let tempEnd = return_time.split(":")
    timeto.setHours((parseInt(tempEnd[0]) - 1 + 24) % 24)
    timeto.setMinutes(parseInt(tempEnd[1]))
    if (return_date==='') {
      if (timefrom>timeto) {
        status = false
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Time Save Time Back'],
          level: 'error',
          position: 'tc'
        })
      }
    } else {
      if (borrowing_date===return_date) {
        if (timefrom>timeto) {
          status = false
          this._notificationSystem.addNotification({
            title: messages['Notice'],
            message: messages['Time Save Time Back'],
            level: 'error',
            position: 'tc'
          })
        }
      }
    }
    return status
  }

  onDateChange(index,key,date) {
    let {data} = this.state
    let status = true
    status = this.convertDate(data[index].borrowing_date,date,index)
    if (!status) {
      data[index][key] = ''
      data[index]['borrowing_time'] = ''
      data[index]['return_time'] = ''
    } else {
      data[index][key] = date
    }
    if (date==='') {
      data[index]['borrowing_time'] = ''
      data[index]['return_time'] = ''
    }  

    this.setState({data:data})
  }

  onTimeSaved(index,key,time) {
    let {data} = this.state
    let status = true

    if (key==='borrowing_time'&&data[index].return_time!=='') {
      status = this.convertTime(time,data[index].return_time,index)
    } else if (key==='return_time'&&data[index].borrowing_time!=='') {
      status = this.convertTime(data[index].borrowing_time,time,index)
    }

    if (!status) {
      data[index][key] = ''
    } else {
      data[index][key] = time
    }
    this.setState({data:data})
  }

  onTextChange(index,key,e) {
    let {data} = this.state
    data[index][key] = e.target.value
    this.setState({data:data})
  }

  onTextSelect(index,key,e) {
    let {data} = this.state
    data[index][key] = e
    this.setState({data:data})
  }

  onColClick(item,index,key,value,e) {
    if(item.is_submit){
      return
    }

    let {data} = this.state
    if(!value){
      data[index][key] = true 
    } else {
      data[index][key] = false 
    }
    
    this.setState({data:data})
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.nickname,
          label: element.nickname,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  onChoiceClick(item,index,key,value,e) {
    if(item.is_submit){
      return
    }
    let {data} = this.state
    if((value===true && data[index][key]===true)||
      (value===false && data[index][key]===false)){
      data[index][key] = ''
    }else{
      data[index][key] = value
    }
    this.setState({data:data})
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    const optionsDay = []
    let {messages} = this.props
    if (all_day) {
      for (var i=0;i<=all_day;i++) {
        if (i == 0) {
          var label = messages['Month']
        } else {
          var label = i
        }
        optionsDay.push({
          value: i,
          label: label
        })
      }
      if (all_day<this.state.defaultDay) {
        var defaultDay = 0
      } else {
        var defaultDay = this.state.defaultDay
      }
    } else {
      optionsDay.push({
        value: 0,
        label: messages['Month']
      })
      var defaultDay = 0
    }

    this.setState({ optionsDay: optionsDay, defaultDay:defaultDay })
    return defaultDay
  }

  onYearChange(e) {
    let {defaultYear,defaultMonth,defaultDay} = this.state
    var year = e.value - 543

    var date = year+"-"+this.state.defaultMonth
    defaultDay = this.getAllDayOfMonth(date)
    defaultYear = e.value
    this.setState({ defaultYear: defaultYear, activePage:1, defaultDay:defaultDay })

    this.loadData(defaultYear,defaultMonth,defaultDay)
  }

  onMonthChange(e) {
    let {defaultYear,defaultMonth,defaultDay} = this.state
    var date = this.state.defaultYear - 543+"-"+e.value
    defaultDay = this.getAllDayOfMonth(date)

    defaultMonth = e.value
    this.setState({ defaultMonth: defaultMonth, activePage:1, defaultDay:defaultDay })

    this.loadData(defaultYear,defaultMonth,defaultDay)
  }

  onDayChange(e) {
    let {defaultYear,defaultMonth,defaultDay} = this.state
    defaultDay = e.value
    this.setState({ defaultDay: defaultDay })

    this.loadData(defaultYear,defaultMonth,defaultDay)
  }

  onTextKeyPress(index,key,e) {
    if (e.charCode === 13) {
      e.preventDefault()
      let {messages} = this.props
      let {customerList,data} = this.state
      let checkSearch = false
      let value = ''

      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.label
        }
      })

      if (checkSearch) {
        data[index][key] = value
      } else {
        data[index][key] = ''
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }

      this.setState({data:data})  
    }  
  }

  getDateConvert(curDate) {
    if(curDate!=='') {
      let d = curDate.substring(0, 2)
      let m = curDate.substring(3, 5)
      let y = curDate.substring(6, 10)
      y = parseInt(y) + 543
      return d+'/'+m+'/'+y
    }
    return
  }

  renderRowData() {
    let {data,customerList,polishing_machine_list} = this.state
    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={12}>{this.props.messages['No Data']}</td></tr>)
    } else {
      return(
        data.map((item,index) => {
          return (
            <tr key={index} className={item.is_submit?'bg-gray-light':''}>
              <td className='text-center' style={{ verticalAlign: 'middle' }}>
                <FormControl style={{textAlign:'center'}} 
                value={item.borrowing_date} disabled={true}></FormControl>
              </td>
              <td className='text-center'>
                <CKAutocomplete
                  disabled={item.is_submit}
                  top={'-34px'}
                  choiceStyle={{width:'200px'}}
                  items={polishing_machine_list}
                  value={item.polishing_machine}
                  onChange={this.onTextChange.bind(this,index,'polishing_machine')}
                  onSelect={this.onTextSelect.bind(this,index,'polishing_machine')}
                />
              </td>
              <td style={{fontSize:'22px'}} className='text-center' onClick={this.onColClick.bind(this,item,index,'sponge',item.sponge)}>
                {item.sponge===true?<FontAwesome name='check'/>:item.sponge===false?'':''}
              </td>
              <td className='text-center'>
                <CKAutocomplete
                  disabled={item.is_submit}
                  top={'-34px'}
                  items={polishing_machine_list}
                  value={item.sponge_pad}
                  onChange={this.onTextChange.bind(this,index,'sponge_pad')}
                  onSelect={this.onTextSelect.bind(this,index,'sponge_pad')}
                />
              </td>
              <td style={{fontSize:'22px'}} className='text-center' onClick={this.onColClick.bind(this,item,index,'scrub',item.scrub)}>
                {item.scrub===true?<FontAwesome name='check'/>:item.scrub===false?'':''}
              </td>
              <td className='text-center'>
                <DatePicker
                  disabled={item.is_submit}
                  value={item.return_date}
                  onChange={this.onDateChange.bind(this,index,'return_date')}
                  showIcon={false}
                  showFooter={true}
                  buddhistEra={true}
                />
              </td>
              <td className='text-center'>
                <CKAutocomplete
                  disabled={item.is_submit}
                  top={'-34px'}
                  items={customerList}
                  value={item.borrower_name}
                  onChange={this.onTextChange.bind(this,index,'borrower_name')}
                  onSelect={this.onTextSelect.bind(this,index,'borrower_name')}
                  onKeyPress={this.onTextKeyPress.bind(this,index,'borrower_name')}
                />
              </td>
              <td className='text-center'>
                <CkTimePicker
                  disabled={item.is_submit}
                  value={item.borrowing_time}
                  onTimeSaved={this.onTimeSaved.bind(this,index,'borrowing_time')}
                  showIcon={false}
                  minuteStep={5}
                />
              </td>
              <td className='text-center'>
                <CkTimePicker
                  disabled={item.is_submit}
                  value={item.return_time}
                  onTimeSaved={this.onTimeSaved.bind(this,index,'return_time')}
                  showIcon={false}
                  minuteStep={5}
                />
              </td>
              <td style={{ fontSize: '22px', verticalAlign: 'middle' }} className='text-center' onClick={this.onChoiceClick.bind(this,item,index,'asset_borrowing',true)}>
                {item.asset_borrowing===true?<FontAwesome name='check' />:item.asset_borrowing===false?'':''}
              </td>
              <td style={{ fontSize: '22px', verticalAlign: 'middle' }} className='text-center' onClick={this.onChoiceClick.bind(this,item,index,'asset_borrowing',false)}>
                {item.asset_borrowing===false?<FontAwesome name='check' />:item.asset_borrowing===true?'':''}
              </td>
              <td className='text-center'>
                <FormControl 
                disabled={item.is_submit}
                value={item.remark} 
                onChange={this.onTextChange.bind(this,index,'remark')}></FormControl>
              </td>
            </tr>
          )
        })
      )
    }
  }

  onRowAdd(number){
    let {data} = this.state
    data = data.concat(this.newEmptyRow(number))
    new Array(data.length).fill('')
    this.setState({data:data})
  }

  renderNewItemButton(){
    let {messages} = this.props
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
          </ButtonToolbar>       
        </Col>
      </Row>
    )
  }

  onSaveClick(e){
    let {messages} = this.props
    let {data,defaultYear,defaultMonth,defaultDay} = this.state
    let postData = {itemlist:data,is_submit:false}
    this.setState({loading:true})
    let that = this
    StockStore.saveStockBorrowing('painter',postData,function(result) {
      if(result.status ==='OK') {
        that.loadData(defaultYear,defaultMonth,defaultDay)
        that._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save Successfully'],
          level: 'info',
          position: 'tc',        
        });
      }else{  
        that.setState({loading:false})
      }
    },function(){
      that.setState({loading:false})
    })
  }

  onSubmitSaveClick(){
    let {data,defaultYear,defaultMonth,defaultDay} = this.state
    let postData = {itemlist:data,is_submit:true}
    let {messages} = this.props
    this.setState({loading:true})
    let that = this
    StockStore.saveStockBorrowing('painter',postData,function(result) {
      if(result.status ==='OK') {
        that.loadData(defaultYear,defaultMonth,defaultDay)
        that._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save Permanently Successfully'],
          level: 'info',
          position: 'tc',        
        });
      }else{  
        that.setState({loading:false})
      }
    },function(){
      that.setState({loading:false})
    })
  }

  onCloseClick(e){
    
  }

  renderTable() {
    let {messages} = this.props
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid table-tool' style={{minWidth:'1280px',marginBottom:'0'}}>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center' style={{ width: '160px' }}>{messages['Borrowing Date']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Polishing Machine']}</th>            
              <th rowSpan={2} className='text-center' style={{ width: '70px' }}>{messages['Sponge']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Sponge Pad']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '70px' }}>{messages['Scrub']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '160px' }}>{messages['Back Date']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Technician']}</th>
              <th colSpan={2} className='text-center'>
                {messages['Time']}
              </th>
              <th colSpan={2} className='text-center'>
                {messages['Accessories']}
              </th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Remark']}</th>
            </tr>
            <tr>
              <th className='text-center' style={{ width: '90px' }}>{messages['Borrow']}</th>
              <th className='text-center' style={{ width: '90px' }}>{messages['Back']}</th>
              <th className='text-center' style={{ width: '70px' }}>{messages['Complete']}</th>
              <th className='text-center' style={{ width: '70px' }}>{messages['Incomplete']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    let {messages} = this.props
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }
    return (
      <Box loading={loading}>
        <Box.Header border={true}>
          {messages['List Painter Tool Borrowing']}
	      </Box.Header>
        <Box.Body>
          <Form inline style={{marginBottom:'5px'}}>
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultYear }
                options={this.state.optionsYear}
                style={{ width: "150px" }}
                onChange={ this.onYearChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultMonth }
                options={this.state.optionsMonth}
                style={{ width: "180px" }}
                onChange={ this.onMonthChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultDay }
                style={{ width: "100px" }}
                options={this.state.optionsDay}
                onChange={this.onDayChange.bind(this)}
              />
            </FormGroup>
            {' '}
            <FormGroup>
              <InputGroup>
                <FormControl placeholder={messages['Searching Technician']+'...'}></FormControl>
                <InputGroup.Addon
                  className=''
                  onClick={''}
                >
                  <FontAwesome name='search' />
                </InputGroup.Addon>
              </InputGroup>
            </FormGroup>
          </Form>
          {this.renderTable()}
          {this.renderNewItemButton()} 
          <NotificationSystem ref="notificationSystem"  style={style}/>                     
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='warning' onClick={this.onSubmitSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save Permanently']}</Button>
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
          </ButtonToolbar>
        </Box.Footer>
      </Box>
    )
  }

}

StockPainterBorrowingRecord.defaultProps = {
  show:false
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockPainterBorrowingRecord}),null,null,{withRef:true},
)(StockPainterBorrowingRecord);


// WEBPACK FOOTER //
// ./src/view/stock/StockPainterBorrowingRecord.js